import * as RadixSlider from '@radix-ui/react-slider';
import type { ReactNode } from 'react';

import { cn } from './cn';

/**
 * Повзунок на Radix. Нативний `<input type="range">` малює операційна
 * система, як і заборонені тут нативні `select` і `checkbox`: у Safari він
 * синій, у Windows сірий, і жоден не знає наших токенів. Radix дає ту саму
 * клавіатуру (стрілки, Home/End, PageUp/PageDown) і `role="slider"`.
 *
 * Одне значення: для фільтра «не дорожче ніж» друга ручка лише заважала б.
 */
export function Slider({
	value,
	onValueChange,
	onValueCommit,
	min,
	max,
	step = 1,
	ariaLabel,
	ariaValueText,
	className,
}: {
	value: number;
	/** Під час руху ручки — для підпису поруч. */
	onValueChange: (value: number) => void;
	/** Коли ручку відпустили — тут дорогі дії: запис в URL, фільтрація. */
	onValueCommit?: (value: number) => void;
	min: number;
	max: number;
	step?: number;
	ariaLabel: string;
	/** Людський текст значення для читачів екрана: «$15,000». */
	ariaValueText?: string;
	className?: string;
}): ReactNode {
	return (
		<RadixSlider.Root
			value={[value]}
			min={min}
			max={max}
			step={step}
			onValueChange={([next]) => next !== undefined && onValueChange(next)}
			onValueCommit={([next]) => next !== undefined && onValueCommit?.(next)}
			className={cn('relative flex h-5 w-full touch-none select-none items-center', className)}
		>
			<RadixSlider.Track className="relative h-1 grow overflow-hidden rounded-full bg-border">
				<RadixSlider.Range className="absolute h-full rounded-full bg-primary-solid" />
			</RadixSlider.Track>
			<RadixSlider.Thumb
				aria-label={ariaLabel}
				aria-valuetext={ariaValueText}
				className="block size-4.5 rounded-full border-2 border-primary bg-surface shadow-e1 transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary/25"
			/>
		</RadixSlider.Root>
	);
}
